import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { BookOpen, Headphones, Calendar } from 'lucide-react';
import { Button } from './ui/Button';
export function OfferSection() {
  const products = [{
    icon: <BookOpen className="w-10 h-10 text-[#0a1628]" data-id="element-152" />,
    title: 'Ebook (Guía Principal)',
    features: ['El sistema completo explicado', 'Ejercicios cortos de aplicación', 'Checklists de verificación', 'Plan de 30 días paso a paso', 'Protocolos de reinicio (para cuando fallas)']
  }, {
    icon: <Headphones className="w-10 h-10 text-[#0a1628]" data-id="element-153" />,
    title: 'Audiolibro',
    subtitle: '(para sostenerte cuando no tienes energía)',
    features: ['Ideal para manejar o caminar', 'Refuerza identidad y ejecución', 'Escúchalo antes de dormir', 'Formato digerible y práctico']
  }, {
    icon: <Calendar className="w-10 h-10 text-[#0a1628]" data-id="element-154" />,
    title: 'Habit Tracker',
    subtitle: '(imprimible + digital)',
    features: ['Diseñado para medir sin culpa', 'Visualiza tu consistencia real', "Convierte 'intento' en 'cumplo'", 'Formato simple y minimalista']
  }];
  return <section className="py-24 md:py-32 bg-[#f8fafc] text-[#0a1628]" data-id="element-155">
      <div className="max-w-6xl mx-auto px-6" data-id="element-156">
        <FadeIn data-id="element-157">
          <div className="text-center mb-16" data-id="element-158">
            <h2 className="text-3xl md:text-5xl font-bold mb-6 text-[#0a1628]" data-id="element-159">
              ¿Qué recibes exactamente?
            </h2>
            <p className="text-xl text-gray-600" data-id="element-160">
              Todo lo que necesitas para instalar el hábito, sin relleno.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-161">
          {products.map((product, index) => <FadeIn key={index} delay={index * 0.2} className="h-full" data-id="element-162">
              <div className="bg-white p-8 rounded-xl shadow-xl border border-gray-100 h-full flex flex-col hover:transform hover:-translate-y-2 transition-transform duration-300" data-id="element-163">
                <div className="w-20 h-20 bg-[#f4e4c1] rounded-full flex items-center justify-center mb-6 mx-auto" data-id="element-164">
                  {product.icon}
                </div>
                <h3 className="text-2xl font-bold text-center mb-2 font-serif" data-id="element-165">
                  {product.title}
                </h3>
                {product.subtitle && <p className="text-sm text-gray-500 text-center mb-6 italic" data-id="element-166">
                    {product.subtitle}
                  </p>}
                <ul className="space-y-4 mt-4 flex-1" data-id="element-167">
                  {product.features.map((feature, i) => <li key={i} className="flex items-start text-gray-700" data-id="element-168">
                      <span className="mr-3 text-[#d4af37] mt-1" data-id="element-169">•</span>
                      <span data-id="element-170">{feature}</span>
                    </li>)}
                </ul>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} data-id="element-171">
          <div className="mt-16 text-center" data-id="element-172">
            <Button className="shadow-2xl" onClick={() => window.open('https://pay.hotmart.com/S104255087F?bid=1770175431852', '_blank')} data-id="element-173">
              Obtener Acceso Inmediato
            </Button>
          </div>
        </FadeIn>
      </div>
    </section>;
}